export const DISPATCH_ROLES_MAPPING = {
    "Admin": "admin",
    "Expéditeur": "dispatcher",
    "Comptable": "accountant",
    "Ressources Humaines": "hr",
    "Lecture seule": "dispatch_readonly",
};

export const MERCHANT_ROLES_MAPPING = {
    "Admin": "merchant",
    "Expéditeur": "merchant_dispatcher",
};

export const carModelOptions = [
  { value: 'Vélo',         label: 'Vélo',               icon: '/img/delivery-bike.png' },
  { value: 'Scooter/moto', label: 'Scooter/moto',       icon: '/img/delivery-scooter.png' },
  { value: 'Coupé',        label: 'Coupé',              icon: '/img/coupe.png' },
  { value: 'Sedan',        label: 'Sedan',              icon: '/img/sedan.png' },
  { value: 'Hatch Back',   label: 'Hatch Back',         icon: '/img/hatchback.png' },
  { value: 'VUS (Camion)', label: 'VUS (Camion)',       icon: '/img/suv.png' },
  { value: 'Minivan',      label: 'Minivan',            icon: '/img/minivan.png' },
  { value: 'Fourgonette(VAN)', label: 'Fourgonette(VAN)', icon: '/img/van.png' },
];

// Average usable volume per package size, in liters.
// Heuristic estimates intended to be tuned by ops; centralized here for easy adjustment.
// small  ~ envelope, pharmacy bag, documents (fits in one hand)
// medium ~ parcel, standard box, shoebox (one hand)
// large  ~ big box, TV, chair (two hands)
export const BOX_VOLUMES = {
  small: 5,
  medium: 20,
  large: 120,
  registered: 5,
  food: 20,
};

// Average usable cargo volume per vehicle type, in liters.
// Keyed by the exact `carModelOptions` values. Estimates, configurable.
// Keep in sync with apps/api/config/vroom.php vehicle_size.volumes (suggestion/planner cost).
export const VEHICLE_VOLUMES = {
  'Vélo': 40,
  'Scooter/moto': 60,
  'Coupé': 300,
  'Sedan': 450,
  'Hatch Back': 650,
  'VUS (Camion)': 1100,
  'Minivan': 1800,
  'Fourgonette(VAN)': 3500,
};

// A shipment (single order) is considered "large" past these package counts per size.
export const LARGE_SHIPMENT_THRESHOLDS = {
  medium: 20,
  large: 4,
};

// Fill ratio (0-1) at/above which a vehicle is flagged as at risk of being full.
export const VEHICLE_FULL_WARNING_RATIO = 0.9;
